import { createSlice } from "@reduxjs/toolkit"

const mapRouteConfig = {
  origin: '',
  destination: '',
  nbAddresses: 10
}

const pilotSlice = createSlice({
  name: 'pilot',
  initialState: {
    pilot: null,
    mapRouteConfig,
    journeySelectedAddresses: {},
    errors: []
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateMapRouteConfig: (state, action) => {
      state.mapRouteConfig = action.payload
    },
    updateJourneySelectedAddresses: (state, action) => {
      state.journeySelectedAddresses = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { fullUpdate, updateMapRouteConfig, updateJourneySelectedAddresses, updateErrors } = pilotSlice.actions

export default pilotSlice.reducer